package com.anjuros.website.templates.template9.sections

import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template9.components.Template9Eyebrow
import com.anjuros.website.templates.template9.components.Template9IconBadge
import com.anjuros.website.templates.template9.components.Template9Sparks
import com.anjuros.website.templates.template9.components.Template9Squiggle
import com.anjuros.website.templates.template9.components.Template9Wave
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.Template9WhyChoose
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.modules.getColorHex
import com.anjuros.website.templates.template9.styles.TEMPLATE9_BLOB_WHY
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9SectionTitleStyle
import com.anjuros.website.templates.template9.styles.Template9WaveStyle
import com.anjuros.website.templates.template9.styles.Template9WhyImageStyle
import com.anjuros.website.templates.template9.styles.template9Blob
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template9WhyChooseSection() {
    Column(
        modifier = Modifier
            .id("whychoose")
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template9Wave(
            modifier = Template9WaveStyle.toModifier(),
            color = Template9Theme.Primary.getColorHex(),
            top = true
        )
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Template9Theme.Primary.getColor())
                .padding(topBottom = 30.px),
            contentAlignment = Alignment.Center
        ) {
            SimpleGrid(
                numColumns = numColumns(base = 1, lg = 2),
                modifier = Template9ContainerStyle.toModifier()
                    .gap(40.px)
            ) {
                Template9Reveal(
                    modifier = Modifier.styleModifier { property("align-self", "center") }
                ) {
                    Column {
                        Template9WhyChooseText()
                    }
                }
                Template9Reveal(
                    modifier = Modifier.fillMaxWidth(),
                    delayMs = 150,
                    contentAlignment = Alignment.Center
                ) {
                    Template9WhyChooseImage()
                }
            }
        }
        Template9Wave(
            modifier = Template9WaveStyle.toModifier(),
            color = Template9Theme.Primary.getColorHex(),
            top = false
        )
    }
}

@Composable
private fun Template9WhyChooseText() {

    Template9Eyebrow(
        text = ResKey.TEMPLATE9_WHY_EYEBROW,
        color = Colors.White
    )

    listOf(ResKey.TEMPLATE9_WHY_CHOOSE_TITLE, ResKey.TEMPLATE9_WHY_CHOOSE_SUBTITLE).forEachIndexed { index, line ->
        P(
            attrs = Template9SectionTitleStyle.toModifier()
                .margin(top = if (index == 0) 14.px else 6.px, bottom = 0.px)
                .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .toAttrs()
        ) {
            Text(LocalText(line))
        }
        Template9Squiggle(width = 110, color = Template9Theme.Accent.hex)
    }

    SimpleGrid(
        numColumns = numColumns(base = 2, lg = 4),
        modifier = Modifier
            .fillMaxWidth()
            .margin(top = 36.px)
            .gap(24.px)
    ) {
        Template9WhyChoose.entries.forEach { item ->
            Column {
                AnjurosIcon(
                    modifier = Modifier.size(34.px),
                    src = item.icon,
                    alt = "why choose this dog walker"
                )
                P(
                    attrs = Modifier
                        .margin(top = 14.px, bottom = 6.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(15.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.White)
                        .toAttrs()
                ) {
                    Text(LocalText(item.title))
                }
                P(
                    attrs = Modifier
                        .margin(0.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(13.px)
                        .lineHeight(1.6)
                        .color(rgb(214, 228, 218))
                        .toAttrs()
                ) {
                    Text(LocalText(item.description))
                }
            }
        }
    }
}

@Composable
private fun Template9WhyChooseImage() {
    Box(
        modifier = Template9WhyImageStyle.toModifier()
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .template9Blob(TEMPLATE9_BLOB_WHY)
                .overflow(Overflow.Hidden)
                .border(width = 6.px, style = LineStyle.Solid, color = Colors.White)
        ) {
            AnjurosImage(
                modifier = Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover),
                src = Template9Res.Image.why_choose,
                alt = "Happy dog enjoying a walk"
            )
        }
        Template9IconBadge(
            modifier = Modifier
                .align(Alignment.CenterStart)
                .margin(left = (-30).px),
            icon = Template9Res.Icon.paw_white,
            alt = "paw",
            accent = true,
            size = 80,
            iconSize = 38
        )
        Template9Sparks(
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .margin(right = (-24).px, bottom = 40.px),
            size = 44,
            color = "#FFFFFF"
        )
    }
}
